"use client";
import { createContext } from "react";
const PortalContainerContext = createContext(null);
export { PortalContainerContext };
